import T from 'i18n-react'
import {
  createSelectorWithPath,
  createSelectorWithEntity,
  labelSelectorFunc,
} from 'helpers/ComponentSelectorUtil'

const valuesSelectorFunc = state => (state.values[0]) ? state.values[0].value : null
const sourcesSelectorFunc = state => state.sources

const sourcesResultFunc = (entities, refs) => (
  refs.map(({id, type}) => {
    const value = entities[type][id].value
    return ({ value, label: value, id})
  }).sort((a, b) => a.id - b.id)
)

export default (path) => {
  const withPath = createSelectorWithPath(path)
  const labelSelector = withPath(labelSelectorFunc)
  const valueSelector = withPath(valuesSelectorFunc)
  const sourceSelectorWithPath = withPath(sourcesSelectorFunc)
  const sourceSelector = createSelectorWithEntity(sourceSelectorWithPath, sourcesResultFunc)

  return {
    labelSelector,
    sourceSelector,
    valueSelector,
  }
}
